import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../config/api';
import type { CarouselRunResult, RenderCarouselBody } from '../types/api';

/**
 * POST /carousel/render → persists a new run + uploads PNGs to GCS.
 *
 * On success invalidates the `['runs']` query so the history page updates.
 */
export function useRenderCarousel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: RenderCarouselBody) =>
      api<CarouselRunResult>('/carousel/render', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['runs'] });
    },
  });
}
